// #region Imports
import { defineComponent, defineAsyncComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    name: 'g-text-html',
    mixins: [appHost.mixins.form],
    components: {
        DxToolbar: defineAsyncComponent(async () => {
            return (await import(/* webpackChunkName: "dxHtmlEeditor"*/ 'devextreme-vue/html-editor')).DxToolbar;
        }),
        DxItem: defineAsyncComponent(async () => {
            return (await import(/* webpackChunkName: "dxHtmlEditor"*/ 'devextreme-vue/html-editor')).DxItem;
        }),
        DxHtmlEditor: defineAsyncComponent(async () => {
            return (await import(/* webpackChunkName: "dxHtmlEditor"*/ 'devextreme-vue/html-editor')).DxHtmlEditor;
        }),
        DxMediaResizing: defineAsyncComponent(async () => {
            return (await import(/* webpackChunkName: "dxHtmlEditor"*/ 'devextreme-vue/html-editor')).DxMediaResizing;
        }),
    },
    props: {
        inputAttr: {
            type: Object,
            required: false,
            default: null,
        },
        rows: {
            type: Number,
            required: false,
            default: 3
        },
        isAutoFill: {
            type: Boolean,
            required: false,
            default: true
        },
    },
    computed: {
        inputAttrInternal() {
            return this.inputAttr;
        },
    },
    methods: {
        onEnterKey(event) {
            this.$emit('EnterKey', event);
        },
    }
});
// #endregion
